export default "__VITE_ASSET__CGXs3QCA__"